'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lock = require('./Lock');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Lock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Lock/index.js
// module id = 1228
// module chunks = 1